export function setClipboard(text: string) {
    const input = document.createElement('input');
    // hack ios popup keyboard
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999);
    input.select();
    // hack ios
    input.setSelectionRange(0, input.value.length);
    document.execCommand('copy');
    document.body.removeChild(input);
}
